import { redirect } from "@/i18n/navigation";
import { EventInfo } from "@/types/event";
import { Calendar, Clock, MapPin } from "lucide-react";
import { useFormatter, useLocale, useTranslations } from "next-intl";


export default function EventCard({data, className, animationDelay}:{data:EventInfo, className:string, animationDelay:number}){
    
  const formatter = useFormatter()
  const l = useLocale();
    const t = useTranslations("societe.rounds")
    const dis = useTranslations("discipline")
    let state = "toCome"
    const from = new Date(data.min)
    const to = new Date(data.max)
    const now = new Date();
    
    if(from<= now){
      if(to <= now){
        state="ended"
      }else{
        state="now"
      }
    }

    function openEvent(){
      redirect({
        href:`/events/${data.id}`,
        locale: l
      })
    }

    return (
        <div
      className={["card-hover p-0! animate-slide-up", className ?? ""].join(" ")}
      style={{ animationDelay: `${animationDelay}ms`}}
      role="button"
      onClick={openEvent}
    >
      {/* ------- TOP PART WITH BG -------- */}
      <div className="bg-surface p-2 rounded-t-xl">
        {/*---------- TOP: Date + timeframe ---------------*/}
        <div className="flex w-full items-center justify-between">
            <span className="flex flex-wrap gap-2 text-sm items-baseline text-primary-on/80"><Calendar className="h-4"/>{formatter.dateTimeRange(from, to, {year: 'numeric', month: 'short', day: 'numeric'})}</span>
            <span className={["rounded-md text-center h-fit px-1 text-nowrap", state=="toCome"?"bg-emerald-500":(state=="now"?"bg-orange-400":"bg-red-500")].join(" ")}>{t(state)}</span>
        </div>
        {/*---------- NAME ---------------*/}
        <div className="text-center font-bold">
          {data.societe.nom}
        </div>
        <div className="text-center font-bold">
          {data.name}
        </div>
      </div>

      <div className="w-full flex flex-wrap justify-around gap-4 p-2">

        <div className="flex justify-center flex-wrap gap-2">
        {data.disciplines.map((d) => (
            <span key={d} className="text-center h-fit px-2 text-nowrap bg-accent-1 py-1 rounded-full">{dis("short." + d)}</span>
        ))}
        </div>

        <div className="flex flex-nowrap items-center">
          <MapPin></MapPin>
          <div className="flex">
            {data.societe.npa}
            	&nbsp;
            {data.societe.localite}
          </div>
        </div>
      </div>
      
    </div>
  )
    
}